// src/components/ui/AuditRow.tsx
import type { AuditEntry } from '@/lib/types/audit';
import { formatSAST } from '@/lib/utils/date';
import { statusColors } from '@/lib/statusColors';

type Props = { entry: AuditEntry; onClick?: () => void };

export function AuditRow({ entry, onClick }: Props) {
  const tone = statusColors(entry.action);

  return (
    <div
      className={`grid items-center px-6 py-4${onClick ? ' cursor-pointer hover:bg-white/5 transition-colors duration-150' : ''}`}
      style={{
        gridTemplateColumns: '14px 200px 280px 1fr 140px',
        gap: 16,
        borderBottom: '1px solid var(--hairline)',
      }}
      onClick={onClick}
    >
      <span
        aria-hidden
        style={{ width: 7, height: 7, borderRadius: 999, background: tone.color, display: 'inline-block' }}
      />
      <span className="mono-meta tabular" style={{ color: 'rgba(var(--fg-rgb),0.55)' }}>
        {formatSAST(entry.timestamp)}
      </span>
      <span
        className="font-sans truncate"
        style={{ color: 'var(--text-primary)', fontSize: 13 }}
      >
        {entry.actorEmail}
      </span>
      <div className="flex items-center gap-3 min-w-0">
        <span
          className="font-mono uppercase tracking-[0.14em]"
          style={{
            fontSize: 10.5,
            color: tone.color,
            padding: '4px 8px',
            borderRadius: 999,
            background: tone.background,
            border: `1px solid ${tone.border}`,
          }}
        >
          {entry.action}
        </span>
        {entry.notes && (
          <span
            className="truncate"
            style={{ color: 'rgba(var(--fg-rgb),0.5)', fontSize: 12.5 }}
          >
            {entry.notes}
          </span>
        )}
      </div>
      <div className="text-right min-w-0">
        <div
          className="font-sans truncate"
          style={{ color: 'rgba(var(--fg-rgb),0.75)', fontSize: 12.5 }}
          title={entry.senderEmail ?? entry.bookingId}
        >
          {entry.senderEmail ?? entry.bookingId.slice(0, 8) + '...'}
        </div>
        {entry.subject && (
          <div
            className="truncate"
            style={{ color: 'rgba(var(--fg-rgb),0.4)', fontSize: 11, marginTop: 2 }}
            title={entry.subject}
          >
            {entry.subject}
          </div>
        )}
      </div>
    </div>
  );
}
